import { render, staticRenderFns } from "./topbar-1.vue?vue&type=template&id=55fdd1ec"
import script from "./topbar-1.vue?vue&type=script&lang=js"
export * from "./topbar-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/topbar/topbar-1.vue
// module id = czdM
// module chunks = 0